module.exports = __webpack_public_path__ + "media/images/flags/64/Aland-70728d33e091dbf076c800b96234b08e.png";